<template>
    <el-row>
        <el-col :span="12">
            <el-row>{{ title }}</el-row>
            <el-row class="specDescription">{{description}}</el-row>
        </el-col>
        <el-col :span="12" class="specControl">
        <el-row>
            <div v-if="selected_tags.length">
                <el-tag        
                    v-for="tag in selected_tags"
                    :key="tag"
                    closable
                    @close="removeProxyTag(tag)"
                    >
                    {{getProxyTagName(tag)}}
                </el-tag>
            </div>
            <div v-else>No tags selected yet</div>
        </el-row>
        <el-row>
            <el-col :span="8">
                <el-select id="groupId" v-model="selectedProxyTag"  size="mini" placeholder="Select tag">
                    <el-option
                    v-for="item in tags_list"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                <el-button v-on:click="addSelectedProxyTag()" size="mini">Add tag</el-button>
            </el-col>
            <el-col :span="6"></el-col>
        </el-row>
        </el-col>
    </el-row>
</template>

<style>

</style>

<script>
export default {
    name: 'UiTags',
    props: {
        title: String,
        description: String,
        selected_tags: {
            type: Array,
            default: () => []
        },
        tags_list: {
            type: Array,
            default: () => []
        }
    },
    methods:{
        getProxyTagName(id) {
            return id;
        },
        removeProxyTag(id) {
            console.log('deleting');
            var tags = this.selected_tags;
            
            tags = tags.filter(function(item){
                if (item != id) return item;
            });
            this.selected_tags = tags;
            this.$emit('input', tags);
        },
        addSelectedProxyTag() {
            var tags = this.selected_tags;
            
            var that = this;//context handler for closure
            var intersect = tags.filter(function(tag){
                if (tag == that.selectedProxyTag) return tag;
            });

            if (intersect.length) {
                return 0;//already in array
            }
            tags.push(this.selectedProxyTag);
            this.selected_tags = tags;
            this.$emit('input', tags);
        },
    },
    data: function () {
        return {
            selected_tags: this.selected_tags,
            selectedProxyTag: ''
        }
    }
}
</script>